(function () {
  if (!customElements.get('et-mega-nav')) {
    class EtMegaNav extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.items = Array.from(this.querySelectorAll('[data-et-mega-item]'));
        this.items.forEach((item) => {
          const toggle = item.querySelector('[data-et-mega-toggle]');
          if (!toggle) return;

          item.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') this.scheduleOpen(item);
          }, { signal });
          item.addEventListener('pointerleave', (event) => {
            if (event.pointerType === 'mouse') this.scheduleClose(item);
          }, { signal });

          toggle.addEventListener('pointerdown', (event) => {
            this.lastPointerType = event.pointerType;
          }, { signal });
          toggle.addEventListener('click', () => {
            const viaMouse = this.lastPointerType === 'mouse';
            this.lastPointerType = null;
            // Hover already opened it; a mouse click shouldn't immediately close it again.
            if (viaMouse && item.classList.contains('is-open')) return;
            this.toggle(item);
          }, { signal });

          item.addEventListener('focusout', (event) => {
            if (event.relatedTarget && !item.contains(event.relatedTarget)) this.close(item);
          }, { signal });
        });

        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.closeAll();
        }, { signal });

        document.addEventListener('keyup', (event) => {
          if (event.key !== 'Escape') return;
          const openItem = this.items.find((item) => item.classList.contains('is-open'));
          if (!openItem) return;
          this.close(openItem);
          openItem.querySelector('[data-et-mega-toggle]').focus();
        }, { signal });

        // The sticky header slides away on scroll; close the panel with it.
        const headerSection = this.closest('.f-section-header');
        if (headerSection) {
          this.observer = new MutationObserver(() => {
            if (headerSection.classList.contains('site-header--hidden')) this.closeAll();
          });
          this.observer.observe(headerSection, { attributes: true, attributeFilter: ['class'] });
        }

        // The theme measures --f-header-height (placeholder height) only on load/resize.
        // Keep it in sync with later header height changes.
        const header = this.closest('[data-section-type="header"]');
        if (header && 'ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            document.documentElement.style.setProperty('--f-header-height', header.offsetHeight + 'px');
          });
          this.resizeObserver.observe(header);
        }
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.observer) this.observer.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
      }

      open(item) {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        this.items.forEach((other) => {
          if (other !== item) this.close(other);
        });
        item.classList.add('is-open');
        item.querySelector('[data-et-mega-toggle]').setAttribute('aria-expanded', 'true');
      }

      close(item) {
        item.classList.remove('is-open');
        item.querySelector('[data-et-mega-toggle]').setAttribute('aria-expanded', 'false');
      }

      toggle(item) {
        if (item.classList.contains('is-open')) {
          this.close(item);
        } else {
          this.open(item);
        }
      }

      scheduleOpen(item) {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        this.openTimer = setTimeout(() => this.open(item), 100);
      }

      scheduleClose(item) {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => this.close(item), 200);
      }

      closeAll() {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        this.items.forEach((item) => this.close(item));
      }
    }
    customElements.define('et-mega-nav', EtMegaNav);
  }

  if (!customElements.get('et-mega-drawer')) {
    class EtMegaDrawer extends HTMLElement {
      connectedCallback() {
        // The mobile drawer is moved to <body> after render, which reconnects this element.
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();

        this.querySelectorAll('[data-et-mnav-toggle]').forEach((toggle) => {
          toggle.addEventListener('click', () => {
            const item = toggle.closest('[data-et-mnav-item]');
            const panel = document.getElementById(toggle.getAttribute('aria-controls'));
            const isOpen = toggle.getAttribute('aria-expanded') !== 'true';
            toggle.setAttribute('aria-expanded', String(isOpen));
            if (item) item.classList.toggle('is-open', isOpen);
            if (panel) panel.hidden = !isOpen;
          }, { signal: this.controller.signal });
        });
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
      }
    }
    customElements.define('et-mega-drawer', EtMegaDrawer);
  }
})();
